import type { WorkbookCell } from "./excel";
import type { BreakdownKind,BreakdownMetric } from "./storeBreakdown";
import type { AnalysisRow } from "./focusedStoreAnalysis";
import type { StoreCategoryScope } from "./storeCategoryMode";
import { storeCategoryCopy } from "./storeCategoryMode";

export type StoreBreakdownExcelSelection={records:Record<string,WorkbookCell>[];search:string};
export type StoreBreakdownExcelSelections=Partial<Record<BreakdownKind,StoreBreakdownExcelSelection>>;
type View={enabled:boolean;language:string;loading:boolean;error?:string;selection?:StoreBreakdownExcelSelection};
const views=new Map<string,View>();
const key=(scope:StoreCategoryScope,kind:BreakdownKind)=>JSON.stringify([scope.releaseId,scope.params,kind]);
export function registerStoreBreakdownExport(scope:StoreCategoryScope,kind:BreakdownKind,view:View){
 const k=key(scope,kind);views.set(k,view);return()=>{if(views.get(k)===view)views.delete(k);};
}
export function readStoreBreakdownExports(scope:StoreCategoryScope,kinds:BreakdownKind[],language:string):StoreBreakdownExcelSelections{
 const selected:StoreBreakdownExcelSelections={};
 for(const kind of kinds){const view=views.get(key(scope,kind));if(!view?.enabled)continue;
  if(view.language!==language)throw Error(storeCategoryCopy(language).changed);
  if(view.error)throw Error(view.error);
  if(view.loading||!view.selection)throw Error(storeCategoryCopy(language).loading);
  selected[kind]={search:view.selection.search,records:view.selection.records.map(r=>({...r}))};
 }
 return selected;
}

// Export the exact sorted/searched screen identities with their unrounded
// numeric fields. Display strings are never parsed back into business values.
export function storeBreakdownExcelSelection(rows:AnalysisRow[],sources:BreakdownMetric[],search:string):StoreBreakdownExcelSelection{
 const source=new Map(sources.map(r=>[JSON.stringify([r.store,r.label]),r]));
 const keys=["target","targetRate","sales","lySales","salesChange","units","lyUnits","unitsChange","unitPrice","lyUnitPrice","unitPriceChange","upt","lyUpt","uptChange","basket","lyBasket","basketChange","receipts","lyReceipts","receiptsChange","visitors","cr","stock","stockShare","share","average","lyAverage","averageChange","days","usd","cumulativeShare"];
 const percent=new Set(["targetRate","cr","stockShare","share","cumulativeShare",...keys.filter(k=>k.endsWith("Change"))]);
 return{search,records:rows.map(row=>{
  const rawLabel=String(row.__sort_label??row.label),raw=source.get(JSON.stringify([row.store,rawLabel]));
  const record:Record<string,WorkbookCell>={store:String(row.store),label:String(row.label),sourceLabel:rawLabel,weekday:String(row.weekday??""),previousDays:raw?.previous_day_count??0};
  for(const k of keys){const value=row["__sort_"+k];record[k]=typeof value==="number"&&Number.isFinite(value)?percent.has(k)?value/100:value:null;}
  if(!Number(record.lyReceipts))record.lyUpt=null;
  return record;
 })};
}
